import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import { translatedMessage } from '../../service/LanguageService';
import GeneralUtils from '../../utilities/GeneralUtils';

const RecruitmentCampaignView = (props) => {
    const [recruitmentCampaign, setRecruitmentCampaign] = useState(null);

    useEffect(() => {
        setRecruitmentCampaign(props?.value);
    }, [props]);

    const hideRecruitmentCampaignDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
        setRecruitmentCampaign(null);
    };

    const recruitmentCampaignDialogFooter = (
        <>
            <Button label={translatedMessage('generic.cancel')} icon="pi pi-times" className="p-button-text" onClick={hideRecruitmentCampaignDialog} />
        </>
    );

    return (
        <>
            <Dialog
                visible={props?.visible}
                header={translatedMessage('recruitment.campaign.details')}
                modal
                resizable={false}
                className="pcn-dialog p-fluid"
                footer={recruitmentCampaignDialogFooter}
                onHide={hideRecruitmentCampaignDialog}
            >
                <div className='w-full grid pcn-data-view-panel'>
                    <div className='col-12 md:col-6'>
                        <div className='filed-label'>{translatedMessage('recruitment.campaign.startDate')}</div>
                        <div className='filed-value'>{GeneralUtils.formatDate(recruitmentCampaign?.startDate)}</div>
                    </div>
                    <div className='col-12 md:col-6'>
                        <div className='filed-label'>{translatedMessage('recruitment.campaign.endDate')}</div>
                        <div className='filed-value'>{GeneralUtils.formatDate(recruitmentCampaign?.endDate)}</div>
                    </div>
                    <div className='col-12 md:col-6'>
                        <div className='filed-label'>{translatedMessage('recruitment.campaign.notification1Days')}</div>
                        <div className='filed-value'>{recruitmentCampaign?.notification1Days}</div>
                    </div>
                    <div className='col-12 md:col-6'>
                        <div className='filed-label'>{translatedMessage('recruitment.campaign.notification2Days')}</div>
                        <div className='filed-value'>{recruitmentCampaign?.notification2Days}</div>
                    </div>
                    <div className='col-12 md:col-6'>
                        <div className='filed-label'>{translatedMessage('generic.status')}</div>
                        <div className='filed-value'>{translatedMessage("RecruitmentCampaignStatus."+recruitmentCampaign?.status)}</div>
                    </div>

                </div>
            </Dialog>
        </>
    );
};

export default RecruitmentCampaignView;
